import React from 'react';

const Loading = () => (
    <div className="text-center py-5 mt-5">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        <p className="pt-1">Loading...</p>
    </div>
);

export default Loading;